import { render, staticRenderFns } from "./cashier-platform.vue?vue&type=template&id=98e2a48c"
import script from "./cashier-platform.vue?vue&type=script&lang=js"
export * from "./cashier-platform.vue?vue&type=script&lang=js"
import style0 from "./cashier-platform.vue?vue&type=style&index=0&id=98e2a48c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports